// eslint-disable-next-line import/no-extraneous-dependencies
import axios from 'axios';
// import pinia from '@/stores';

// import { useCustomerStore } from '@/stores/customer';

// axios.interceptors.request.use(async (req) => {
//   const customerStore = useCustomerStore(pinia);

//   const token = customerStore.Jwt;
//   if (token) {
//     req.headers.Authorization = `Bearer ${token}`;
//   }
//   return req;
// });

axios.interceptors.response
  .use(
    (response) => response,
    async (error) => Promise.reject(error),
  );

export default ((request) => axios(request));
